const reserveStore = {
    state: {
        // 진료예약 완료
        reserve: '',
        // 진료변경
        change: '',
        // 진료예약
        info: '',
        // 의료진 진료예약
        normalReserve: '',
        // 의료진 빠른예약
        quickReserve: '',
        // 혈압수첩 등록
        bloodDate: '',
        // 산모일기 등록
        diaryDate: '',
    },
    mutations: {
        setReserve: function (state, reserve) {
            state.reserve = reserve;
        },
        setChange: function (state, change) {
            state.change = change;
        },
        setReserveInfo: function (state, info) {
            state.info = info;
        },
        setNormalReserve: function (state, normalReserve) {
            state.normalReserve = normalReserve;
        },
        setQuickReserve: function (state, quickReserve) {
            state.quickReserve = quickReserve;
        },
        setBloodDate: function (state, bloodDate) {
            state.bloodDate = bloodDate;
        },
        setDiaryDate: function (state, diaryDate) {
            state.diaryDate = diaryDate;
        },

        // 초기화
        reserveInit: function(state){
            for(let i in state) {
                if(i != 'reserve') state[i] = ''
            }
        }
    }
}

export default reserveStore